/**
 * Ryan O'Dowd
 * 2022-04-12
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  TouchableOpacity,
  View,
} from 'react-native';
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const ButtonGroup = (props: ButtonGroupProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View
      style={[
        styles.container,
        props.isVertical && styles.vertical,
        props.containerStyles,
        props.options.some((o) => o.rightItem) && styles.containerWithRightItems,
      ]}
    >
      {props.options.map((option, index) => {
        return (
          <View
            key={`${option.value}${props.selectedValue}`}// @TODO: there has to be a better way to force a rerender when the selectedValue changes...
            style={[
              styles.optionWrapper,
              props.isVertical && styles.optionWrapperVertical,
              (!props.isVertical || option.rightItem) && styles.optionWrapperWithRightItem,
            ]}
          >
            <View style={[styles.sectionTitleAndOptionWrapper, !props.isVertical && styles.sectionTitleAndOptionWrapperHorizontal]}>
              {option.sectionTitle && <Text style={styles.sectionTitleText}>{option.sectionTitle}</Text>}
              <TouchableOpacity
                disabled={props.disabled}
                style={[
                  styles.option,
                  (props.selectedValue === option.value) && styles.selected,
                  (index === 0 || !!option.sectionTitle) && (props.isVertical ? styles.firstVertical : styles.first),
                  ((index === props.options.length - 1) || !!props.options[index + 1]?.sectionTitle) && (props.isVertical ? styles.lastVertical : styles.last),
                  option.rightItem && styles.optionWithRightItem,
                  props.dense && styles.optionDense,
                ]}
                onPress={() => props.onSelect(option.value)}
              >
                <Text
                  style={[styles.optionText, option.textStyle]}
                  numberOfLines={2}
                  adjustsFontSizeToFit={true}
                >
                  {option.title}
                </Text>
              </TouchableOpacity>
            </View>
            {option.rightItem}
          </View>
          // @TODO: info marker with descriptions if available
        );
      })}
    </View>
  );
};

class ButtonGroupProps {
  onSelect: (value: any) => void;
  options: {
    sectionTitle?: string;
    title: string;
    value: string | number;

    description?: string; // @TODO: maybe just remove completely?
    rightItem?: React.ReactNode;
    textStyle?: any;
  }[];

  containerStyles?: any;
  disabled?: boolean;
  dense?: boolean;
  selectedValue?: string | number;
  isVertical?: boolean;
  includeCustomCurrencyInput?: boolean; // @TODO: web-only at the moment...here to avoid ts errors, but seems like too much business logic for this component
};

export default ButtonGroup;

// @TODO: below is the initial web code that might be required when fundraising is active again
///**
// * Ryan O'Dowd
// * 2022-07-23
// * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
// */
//import {
//  Button,
//  Dialog,
//  DialogActions,
//  DialogContent,
//  DialogTitle,
//} from '@mui/material';
//import React, {
//  useState,
//} from 'react';
//import CurrencyInput from 'react-currency-input-field';
//import getStyles from './styles';
// import hooks from '@hooks';
//
//const ButtonGroup = (props: ButtonGroupProps) => {
//  const styles = hooks.useStyles(getStyles);
//  const [_customAmount, setCustomAmount] = useState(0);
//  const [_tempCustomAmount, setTempCustomAmount] = useState(0);
//  const [_customSelected, setCustomSelected] = useState(false);
//  const [_isCustomDialogOpen, setIsCustomDialogOpen] = useState(false);
//
//  return (
//    <div style={{...styles.container, ...props.containerStyles}}>
//      {props.options.map((option, index) => {
//        return (
//          <span
//            key={`${option.value}${props.selectedValue}`}// @TODO: there has to be a better way to force a rerender when the selectedValue changes...
//            style={{
//              ...styles.option,
//              ...((!_customSelected && props.selectedValue === option.value) ? styles.selected : {}),
//              ...(index === 0 ? styles.first : {}),
//              ...((!props.includeCustomCurrencyInput && index === props.options.length - 1) ? styles.last : {}),
//              ...(((index !== 0) && (index !== props.options.length - 1)) ? styles.middle : {}),
//            }}
//            onClick={() => {
//              setCustomSelected(false);
//              props.onSelect(option.value);
//            }}
//          >
//            <span>{option.title}</span>
//          </span>
//          // @TODO: info marker with descriptions if available
//        );
//      })}
//      {props.includeCustomCurrencyInput && (
//        <React.Fragment>
//          <span
//            key='customInput'
//            style={{
//              ...styles.option,
//              ...(_customSelected ? styles.selected : {}),
//              ...styles.last,
//            }}
//            onClick={() => {
//              setCustomSelected(true);
//              setIsCustomDialogOpen(true);
//              props.onSelect(_customAmount);
//            }}
//          >
//            {_customAmount
//              ? <span>{utilities.prettyCurrency(_customAmount)}</span>
//              : <span style={styles.customAmountText}>Custom amount</span>
//            }
//          </span>
//          <Dialog
//            style={styles.customInputDialog}
//            open={_isCustomDialogOpen}
//            fullScreen={false}
//            onClose={() => setIsCustomDialogOpen(false)}
//          >
//            <DialogTitle id='alert-dialog-title'>
//              Set custom amount
//            </DialogTitle>
//            <DialogContent style={styles.innerContainer}>
//              <CurrencyInput
//                style={styles.customInput}
//                placeholder='Enter custom amount here'
//                disableGroupSeparators={true}
//                allowNegativeValue={false}
//                autoFocus={true}// @TODO: doesn't work
//                decimalsLimit={2}
//                decimalScale={2}
//                onValueChange={(value, name) => {
//                  setTempCustomAmount(+value);
//                }}
//                prefix='$'
//                disableAbbreviations={true}
//              />
//            </DialogContent>
//            <DialogActions>
//              <Button
//                color='primary'
//                onClick={() => {
//                  setIsCustomDialogOpen(false);
//                }}
//              >
//                Cancel
//              </Button>
//              <Button
//                color='primary'
//                variant='contained'
//                onClick={() => {
//                  setCustomAmount(_tempCustomAmount * 100);
//                  props.onSelect(_tempCustomAmount * 100);
//                  setIsCustomDialogOpen(false);
//                }}
//              >
//                Save
//              </Button>
//            </DialogActions>
//          </Dialog>
//        </React.Fragment>
//      )}
//    </div>
//  );
//};
//
//class ButtonGroupProps {
//  onSelect: (value: any) => void;
//  options: {
//    title: string;
//    value: string | number;
//  }[];
//
//  includeCustomCurrencyInput?: boolean;
//  containerStyles?: any;
//  selectedValue?: string | number;
//};
//
//export default ButtonGroup;
